export default {
    title: 'Participants',
    action: 'Manage participants',
    join: 'Participate'
}
